import { useState, useEffect } from "react";

export const usePermissions = () => {
  const [permissions, setPermissions] = useState({
    canAdd: false,
    canUpdate: false,
    canDelete: false,
    dispatchDate: false,
    user: null,
    actions: [],
  });

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));

    const canAdd = user?.order_management_add === 1;
    const canUpdate = user?.ordermanagement_update === 1;
    const canDelete = user?.ordermanagement_delete === 1;
    const dispatchDate = user?.order_dispatchdate_update === 1;

    const actions = [];

    if (canUpdate) {
      actions.push({
        icon: "lucide:edit",
        className: (order) =>
          `w-32-px h-32-px me-8 bg-success-focus rounded-circle d-inline-flex align-items-center justify-content-center 
           ${order.status === "processing" ? "bg-secondary" : "bg-success-focus text-success-main"}`,
        handler: null, // Will be set by parent
        disabled: (order) =>
          order.status === "processing" || order.status === "readytodispatch",
      });
    }

    if (canDelete) {
      actions.push({
        icon: "mingcute:delete-2-line",
        className:
          "w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center",
        handler: null,
      });
    }

    actions.push({
      icon: "mdi:history",
      className:
        "w-32-px h-32-px me-8 bg-secondary-focus text-secondary-main rounded-circle d-inline-flex align-items-center justify-content-center",
      handler: null,
    });

    setPermissions({
      canAdd,
      canUpdate,
      canDelete,
      dispatchDate,
      user,
      actions,
    });
  }, []);

  return permissions;
};
